import { ENVIRONMENT_CONFIGS, EnvironmentType } from '@/types/config';

const environment = (import.meta.env.VITE_ENVIRONMENT || 'development') as EnvironmentType;
const envConfig = ENVIRONMENT_CONFIGS[environment] || ENVIRONMENT_CONFIGS.development;

export function EnvironmentBanner() {
  if (!envConfig.showBanner) {
    return null;
  }

  return (
    <div
      className={`${envConfig.bannerColor || 'bg-warning-500'} text-white text-center py-1 px-4 text-sm font-medium`}
    >
      {envConfig.bannerText}
    </div>
  );
}
